import script from "./FarmingSteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./FarmingSteps.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__